import styled from 'styled-components'
import { handleFontSize, handleFontWeight } from 'styles/typography'
import {
  MdCheckCircleOutline,
  MdErrorOutline,
  MdOutlineWarning,
} from 'react-icons/md'

export const BubbleWrapper = styled.div<{
  color?: string
  noMargin?: boolean
}>`
  padding: 20px;
  border-radius: 5px;
  font-size: ${() => handleFontSize('lg')};
  color: ${({ theme, color }) => theme[color]};
  background: ${({ theme, color }) => theme[color]}1A;
  border: 1px solid ${({ theme, color }) => theme[color]};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: ${({ noMargin }) => (noMargin ? '0' : '10px')};

  > svg {
    min-width: 20px !important;
  }

  > span {
    cursor: pointer;
    font-weight: ${() => handleFontWeight('base')};
    border-bottom: 1px solid;
    margin: 0 -4px;
  }
`

interface BubbleProps {
  text?: string
  type?: 'error' | 'warning' | 'success'
  noMargin?: boolean
  children?: React.ReactNode
}

export const Bubble: React.FC<BubbleProps> = ({
  text = '',
  type = 'error',
  noMargin = false,
  children,
}) => {
  // Match color with type
  let color = 'highlight'
  switch (type) {
    case 'error':
      color = 'red'
      break
    case 'warning':
      color = 'orange'
      break
    case 'success':
      color = 'green'
      break
    default:
      break
  }

  const renderIcon = () => {
    switch (type) {
      case 'error':
        return <MdErrorOutline />
      case 'warning':
        return <MdOutlineWarning />
      case 'success':
        return <MdCheckCircleOutline />
      default:
        return null
    }
  }

  return (
    <BubbleWrapper color={color} noMargin={noMargin}>
      {renderIcon()}
      {children ?? text}
    </BubbleWrapper>
  )
}
